import React, { useState, useEffect } from 'react'
import { Team } from './components/team'
import { Navigation } from './components/navigation'
import { Contact } from './components/contact'
import { Clients } from './components/clients'
import { Header } from './components/header'
import { News } from './components/news'
import { Services } from './components/services'
import { Briefcase } from './components/briefcase'
import CookieConsent from 'react-cookie-consent'
import { ScrollToTop } from './components/scrollToTop'
import { CookiesPolicy } from './components/cookiesPolicy'
import { AnalyticNews } from './components/analyticNews'

import { NewsHome } from './components/news/news-home'
import { NewsletterHome } from './components/newsletters/newsletter-home'
import { PlaneacionLiquida } from './components/news/planeacion-liquida'
import { DesbloqueandoPotencial } from './components/news/desbloqueando-potencial'
import { DataDrivenMarketing } from './components/news/data-driven-marketing'
import { GrowthMarketing } from './components/news/growth-marketing'
import { PotenciandoEstrategias } from './components/news/potenciando-estrategias'

import { ServicesHome } from './components/services/services-home'

import { BriefcaseHome } from './components/briefcase/briefcase-home'
import { Portafolio } from './components/briefcase/portafolio'

import { BuyerPersona } from './components/services/buyer-persona'
import { ServiciosDigitales } from './components/services/servicios-digitales'
import { AnalisisDatos } from './components/services/analisis-datos'
import { CrecimientoExponencial } from './components/services/crecimiento-exponencial'
import { TecnologiaMarketing } from './components/services/tecnologia-marketing'

import JsonData from './data/data.json'
import NewslettersData from './data/newsletters.json'
import { Navigate, Route, Routes } from 'react-router-dom'
import { positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import './App.css'
import $ from 'jquery'
import { BrandEquity } from './components/news/brand-equity'
import { Recesion } from './components/news/recesion'
import { InteligenciaArtificial } from './components/news/inteligencia-artificial'
import FloatingContactButton from './components/FloatingContactButton'

const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
}

let enter = false

/**
 * Component inicial donde se configura las rutas de cada una de las opciones
 *
 * @component
 */

const App = () => {
  const controlNavbar = () => {
    if (typeof window !== 'undefined') {
      $('#btnMenu')
        .not('.collapsed')
        .trigger('click')
    }
  }

  const [landingPageData, setLandingPageData] = useState({})
  const [newslettersData, setNewslettersData] = useState([])
  useEffect(() => {
    setLandingPageData(JsonData)
    setNewslettersData(NewslettersData)
    document.documentElement.lang = 'es'

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavbar)

      // cleanup function
      return () => {
        window.removeEventListener('scroll', controlNavbar)
      }
    }
  }, [])

  $(function() {
    if ($('#rcc-confirm-button') !== undefined && !enter) {
      enter = true
      $('#rcc-confirm-button')
        .parent()
        .css('text-align', 'center')
      $('#rcc-confirm-button')
        .parent()
        .addClass('text-center-cookies')
      $('<br>').insertAfter('#rcc-confirm-button')
    }
  })

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Navigation />
              <Header data={landingPageData.Header} />
              <Services
                data={landingPageData.Services}
                dataBriefcase={landingPageData.Briefcase}
              />
              <News data={landingPageData.News} />
              <Briefcase data={landingPageData.Briefcase} />
              <Clients data={landingPageData.Testimonials} />
              <Team data={landingPageData.Team} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
              <CookieConsent
                location="bottom"
                buttonText="Aceptar todas las cookies"
                declineButtonText="Rechazarlas todas"
                enableDeclineButton={true}
                flipButtons={true}
                // debug={true}
                cookieName="myAwesomeCookieName2"
                style={{ background: '#F7C946', color: '#000000' }}
                buttonStyle={{
                  background: '#333333',
                  color: '#FFFFFF',
                  fontSize: '11px',
                  padding: '10px',
                  margin: '10px 15px 0px 15px',
                  width: '190px',
                }}
                declineButtonStyle={{
                  background: '#E2E2E2',
                  color: '#000000',
                  fontSize: '11px',
                  padding: '10px',
                  margin: '10px 15px 15px 15px',
                  width: '190px',
                }}
                expires={150}
                contentStyle={{ display: 'grid' }}
              >
                <p
                  style={{
                    textAlign: 'justify',
                    paddingLeft: '40px',
                    paddingRight: '40px',
                    paddingTop: '20px',
                    paddingBottom: '20px',
                    fontSize: '11px',
                  }}
                >
                  Estimado visitante, le informamos que este sitio utiliza
                  mecanismos de seguimiento de sitios web (denominados cookies)
                  para poder operar de manera adecuada, adicionalmente también
                  utilizamos cookies por parte de terceros para mejorar
                  continuamente nuestros servicios y para mostrar anuncios de
                  acuerdo con los intereses de los usuarios. Al aceptar este
                  mensaje, estoy aceptando el uso de cookies por parte de esta
                  web.{' '}
                  <a
                    className="linkPoliticas"
                    href="/CookiesPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política de Cookies
                  </a>{' '}
                  <a
                    className="linkPoliticas"
                    href="/AnalyticNews"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Protección de Datos
                  </a>
                </p>
              </CookieConsent>
            </div>
          }
        />
        <Route
          path="/equipo"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <Team data={landingPageData.Team} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
              {/* <FloatingWhatsApp phoneNumber={landingPageData.Contact ? landingPageData.Contact.WSphoneNumber : ''}
              accountName={landingPageData.Contact ? landingPageData.Contact.WSaccountName : ''}
              chatMessage={landingPageData.Contact ? landingPageData.Contact.WSchatMessage : ''}
              placeholder={landingPageData.Contact ? landingPageData.Contact.WSplaceholder : ''}
              avatar={landingPageData.Contact ? landingPageData.Contact.WSavatar : ''}
              statusMessage={landingPageData.Contact ? landingPageData.Contact.WSstatusMessage : ''}
              allowEsc
              allowClickAway /> */}
            </div>
          }
        />
        <Route
          path="/clientes"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <Clients data={landingPageData.Testimonials} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <NewsHome data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/newsletter"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <NewsletterHome data={newslettersData} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/planeacion-liquida"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <PlaneacionLiquida data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/desbloqueando-potencial"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <DesbloqueandoPotencial data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/data-driven-marketing"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <DataDrivenMarketing data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/growth-marketing"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <GrowthMarketing data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/potenciando-estrategias"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <PotenciandoEstrategias data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/brand-equity"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <BrandEquity data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/news/recesion"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <Recesion data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
         <Route
          path="/news/inteligencia-artificial"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <InteligenciaArtificial data={landingPageData.News} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/servicios"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <ServicesHome data={landingPageData.Services} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/nuestrotrabajo"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <BriefcaseHome data={landingPageData.Briefcase} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/nuestrotrabajo/portafolio/:id"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <Portafolio data={landingPageData.Briefcase} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/servicios/buyerPersona"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <BuyerPersona data={landingPageData.Services} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/servicios/serviciosdigitales"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <ServiciosDigitales data={landingPageData.Services} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/servicios/analisisdedatos"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <AnalisisDatos data={landingPageData.Services} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/servicios/crecimientoexponencial"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <CrecimientoExponencial data={landingPageData.Services} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/servicios/tecnologiamarketing"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <TecnologiaMarketing data={landingPageData.Services} />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/CookiesPolicy"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <CookiesPolicy />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route
          path="/AnalyticNews"
          element={
            <div>
              <ScrollToTop />
              <Navigation />
              <AnalyticNews />
              <AlertProvider template={AlertTemplate} {...options}>
                <Contact
                  data={landingPageData.Contact}
                  dataNews={landingPageData.News}
                  dataServices={landingPageData.Services}
                />
                <FloatingContactButton targetId="contactanos" />
              </AlertProvider>
            </div>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  )
}

export default App
